import { useState } from 'react';
import { Input } from 'antd';
import { SearchOutlined } from "@ant-design/icons";
import { useNavigate } from 'react-router-dom';
import SearchService from '../../services/SearchService';
import styles from './SearchBar.module.scss';

export default function SearchBar() {
    const [searchQuery, setSearchQuery] = useState('');
    const [suggestions, setSuggestions] = useState([]);
    const navigate = useNavigate();

    const handleSearch = async (query) => {
        if (query.length > 0) {
            try {
                const result = await SearchService.getInstance().search(query);
                setSuggestions(result.data);
            } catch (error) {
                console.error("Erreur lors de la recherche:", error);
            }
        } else {
            setSuggestions([]);
        }
    };

    const handleSuggestionClick = (item) => {
        switch (item.type) {
            case 'user':
            navigate(`/user/${item.uid}`);
            break;
            case 'tache':
            navigate(`/tache/${item.uid}`);
            break;
            case 'affaire':
            navigate(`/affaire/${item.uid}`);
            break;
            default:
            console.warn(`Unknown type: ${item.type}`);
        }
    };

    return (
        <div className={`${styles.searchContainer} mx-2`}>
            <Input
                placeholder="Rechercher..."
                prefix={<SearchOutlined className={styles.searchIcon} />}
                className={styles.searchBar}
                value={searchQuery}
                onChange={(e) => {
                    setSearchQuery(e.target.value);
                    handleSearch(e.target.value);
                }}
            />
            {suggestions.length > 0 && (
                <div className={styles.suggestionsContainer}>
                    <ul className={styles.suggestionsList}>
                        {suggestions.map((item) => (
                            <li
                                key={item.uid}
                                onClick={() => handleSuggestionClick(item)}
                                className={styles.suggestionItem}
                            >
                                {item.avatar ? (
                                    <img
                                        src={item.avatar}
                                        alt={item.name}
                                        className={styles.suggestionIcon}
                                    />
                                ) : (
                                    <i
                                        className={item.icon ? item.icon : `bi bi-people`}
                                        style={{ marginRight: '10px', fontSize: '18px' }}
                                    ></i>
                                )}
                                <span className={styles.suggestionText}>{item.name}</span>
                            </li>
                        ))}
                    </ul>
                </div>
            )}
        </div>
    );
}
